import { AiAgentLogo } from './AiAgentLogo'

interface AiAgentLoadingMessageProps {
  text?: string
  showText?: boolean
  showAvatar?: boolean
}

function AiAgentLoadingMessage({
  text = 'AL is typing',
  showText = false,
  showAvatar = true,
}: AiAgentLoadingMessageProps) {
  return (
    <div className='ai-agent-msg ai-agent-msg--assistant' data-testid='ai-agent-loading-message'>
      {showAvatar && <AiAgentLogo className='ai-agent-avatar-small' iconType='head' size={20} />}
      <div className='ai-agent-bubble' aria-live='polite' aria-label={text}>
        <span className='ai-agent-loading-content'>
          {showText && <span className='ai-agent-loading-text'>{text}</span>}
          <span className='ai-agent-ellipsis' data-testid='ai-agent-ellipsis'>
            <span className='ai-agent-ellipsis-dot' data-testid='ellipsis-dot' />
            <span className='ai-agent-ellipsis-dot' data-testid='ellipsis-dot' />
            <span className='ai-agent-ellipsis-dot' data-testid='ellipsis-dot' />
          </span>
        </span>
      </div>
    </div>
  )
}

export { AiAgentLoadingMessage }
